import { SVGProps } from 'react'

export const DoneIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16rem"
      height="16rem"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4716_14915)">
        <path
          opacity="0.2"
          d="M8 0C3.58885 0 0 3.58885 0 8C0 12.4112 3.58885 16 8 16C12.4112 16 16 12.4112 16 8C16 3.58885 12.4112 0 8 0Z"
          fill="white"
        />
        <path
          d="M8 2C4.69163 2 2 4.69163 2 8C2 11.3084 4.69163 14 8 14C11.3084 14 14 11.3084 14 8C14 4.69163 11.3084 2 8 2Z"
          fill="white"
        />
        <path
          d="M8 5C6.34582 5 5 6.34582 5 8C5 9.65418 6.34582 11 8 11C9.65418 11 11 9.65418 11 8C11 6.34582 9.65418 5 8 5Z"
          fill="white"
        />
        <path
          d="M5 8L7.26733 11.2671L10.5 6"
          stroke="black"
          strokeWidth="1.575"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4716_14915">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
